import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getTag = (payload, callback) => req.list(
  c.GET_TAG,
  '/api/v1/administrators/application_status_requirements',
  payload,
  callback,
);

export const removeTag = (id, payload, callback) => req.remove(
  c.REMOVE_TAG,
  `/api/v1/administrators/application_status_requirements/${id}`,
  payload,
  (res) => {
    const { message } = res.res;
    alert.success(message || 'Successfully remove your tagged Requirement!');
    if (callback) callback();
  },
);

export const getRequirementList = (payload, callback) => req.list(
  c.GET_REQUIREMENT_LIST, 
  // '/api/v1/administrators/application_status_requirements/',
  '/api/v1/administrators/requirements/',
  payload,
  callback,
);

export const getPermitTypeList = (payload, callback, type = 'PSA') => req.list(
  c.GET_PERMIT_TYPE_LIST,
  `/api/v1/administrators/module_systems/${type}/application_statuses`,
  payload,
  callback,
);

export const updateApplicationRequirements = (payload, callback) => req.update(
  c.UPDATE_APPLICATION_REQUIREMENT,
  '/api/v1/administrators/application_status_requirements/set',
  payload,
  callback,
);
